var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlertaDeConexionDeTomaDeFuerza(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.12 255.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ba79f2;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-alerta-de-conexion-de-toma-de-fuerza") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_38_copia_14",
    "data-name": "38 copia 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.14,196a31.92,31.92,0,0,0-63.76,0c0,.54,0,1.09,0,1.64a31.92,31.92,0,1,0,63.84,0C148.18,197.05,148.17,196.5,148.14,196Zm-31.88,22.09A20.46,20.46,0,0,1,95.8,197.6c0-.56,0-1.1.08-1.64a20.44,20.44,0,0,1,40.76,0c0,.54.07,1.08.07,1.64A20.45,20.45,0,0,1,116.26,218.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.77,180.65a27.77,27.77,0,0,0-49,0,27.44,27.44,0,0,0-3.24,11.64c0,.47,0,1,0,1.43a26.87,26.87,0,0,0,.27,3.83H92a25.48,25.48,0,0,1-.3-3.83c0-.61,0-1.26.09-2a24.59,24.59,0,0,1,49,0c.06.71.08,1.36.08,2a24.24,24.24,0,0,1-.3,3.83h3.22a28.42,28.42,0,0,0,.27-3.83c0-.48,0-1,0-1.43h0A27.29,27.29,0,0,0,140.77,180.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.4,161.79a36.12,36.12,0,0,1,15,15,35.66,35.66,0,0,1,4.21,15.13c0,.61,0,1.23,0,1.85a37.33,37.33,0,0,1-.21,3.83h33.26l-11-35.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.82,193.72c0-.62,0-1.24.05-1.85a35.66,35.66,0,0,1,4.21-15.13,36.06,36.06,0,0,1,15-15H25.72v35.76H74A34.7,34.7,0,0,1,73.82,193.72Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.36 152.44 134.32 152.44 16.39 90.3 19.36 152.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.24 74.28 27.24 94.95 220.19 198.61 228.82 182.57 27.24 74.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.67 120.95 59.62 112.33 74.41 99.6 90.46 108.21 75.67 120.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.29 103.57 27.24 94.95 42.03 82.22 58.08 90.83 43.29 103.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.59 138.62 92.54 130.01 107.33 117.27 123.38 125.89 108.59 138.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.16 156.11 125.11 147.49 139.9 134.76 155.95 143.37 141.16 156.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.09 173.78 158.04 165.17 172.83 152.44 188.88 161.05 174.09 173.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.39 190.59 189.34 181.98 204.13 169.24 220.19 177.86 205.39 190.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.4,84.94a12,12,0,0,0-12.34-6.58c-3.52.4-5.91,2.37-8,4.43l-30.86,30.9-15.71,15.7-19.06,19.07c-2.47,2.47-4.93,4.95-7.5,7.54l-1.73,1.74-2.55-2.55q-16.23-16.26-32.49-32.48A11.9,11.9,0,0,0,53,122.6a11.74,11.74,0,0,0-3.47,8.5,12.2,12.2,0,0,0,3.61,8.57C68.4,155,82.36,168.93,95.86,182.4a13.11,13.11,0,0,0,9.29,4,13.5,13.5,0,0,0,9.53-4.16q22-22.09,44.11-44.15L180,116.93q9.1-9.11,18.2-18.21A12,12,0,0,0,200.4,84.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.56,19.87a107.69,107.69,0,0,1,76.15,183.84A107.69,107.69,0,0,1,51.41,51.41a107,107,0,0,1,76.15-31.54m0-19.87A127.56,127.56,0,1,0,255.12,127.56,127.56,127.56,0,0,0,127.56,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertaDeConexionDeTomaDeFuerza);
export default __webpack_public_path__ + "static/media/ic-alerta-de-conexion-de-toma-de-fuerza.899e605eb079048673487fa60d1f5feb.svg";
export { ForwardRef as ReactComponent };